'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react/addons');
var _React$addons = React.addons;
var classSet = _React$addons.classSet;
var CSSTransitionGroup = _React$addons.CSSTransitionGroup;

var TitledGroup = React.createClass({
  displayName: 'TitledGroup',

  render: function render() {
    var props = this.props;
    var title = props.title;

    var classes = {};
    classes['titled-group-component'] = true;
    classes[props.className || ''] = true;

    var titleNode = null;

    if (title && title.length > 0) {
      titleNode = React.createElement(
        'div',
        { className: 'title' },
        title
      );
    }

    return React.createElement(
      'div',
      _extends({}, props, { className: classSet(classes) }),
      React.createElement(
        CSSTransitionGroup,
        { component: 'div', transitionName: 'title-transition', className: 'title-wrapper' },
        titleNode
      ),
      React.createElement(
        'div',
        { className: 'content' },
        props.children
      )
    );
  }

});

module.exports = TitledGroup;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/ui/titled-group.js
 **/